import { api, apiMipe } from '@/core/api/'
const URL = 'api/SpecialInform'

export default {
  getTopics() {
    return api.get(`${URL}/topics`)
  },
  getSubTopics(subId) {
    return api.get(`${URL}/subtopics/${subId}`)
  },
  getColumns(subTopicId) {
    return api.get(`${URL}/subtopiccolumns/${subTopicId}`)
  },
  getSpecialReport(id) {
    return api.get(`${URL}/specialinform/${id}`)
  },
  getConditionals() {
    return api.get(`${URL}/conditionals`)
  },
  getSource(columnId) {
    return api.get(`${URL}/source/${columnId}`)
  },
  getPreview(payload) {
    return api.post(`${URL}/previewreport`, payload)
  },
  saveReport(payload) {
    return api.post(`${URL}/save`, payload)
  },
  search(payload) {
    return api.get(`${URL}/search`, {
      params: {
        ...payload
      }
    })
  },
  getInitFilters() {
    return api.get(`${URL}/initfilters`)
  },
  generate(payload) {
    return api.post(`${URL}/generate`, payload)
  },
  cancel(id) {
    return api.post(`${URL}/cancel/${id}`)
  },
  download(id) {
    return api.get(`${URL}/download/${id}`)
  },
  inactivate(id) {
    return api.put(`${URL}/inactivate/${id}`)
  },
  activate(id) {
    return api.put(`${URL}/activate/${id}`)
  },
  addToFavorites(id) {
    return api.post(`${URL}/addfavorite/${id}`)
  },
  removeToFavorites(id) {
    return api.delete(`${URL}/removefavorite/${id}`)
  },
  getSharedUser(id) {
    return api.get(`${URL}/sharedusers/${id}`)
  },
  share(payload) {
    return api.post(`${URL}/share`, payload)
  },
  removeSharedUser(queryBuilderId, userId) {
    return api.delete(`${URL}/sharedusers/${queryBuilderId}/${userId}`)
  },
  getTags() {
    return api.get(`${URL}/tags`)
  },
  getTagByQueryBuilderId(queryBuilderId) {
    return api.get(`${URL}/tags/${queryBuilderId}`)
  },
  addTag(queryBuilderId, name) {
    return api.post(`${URL}/tags/${queryBuilderId}/${name}`)
  },
  removeTag(queryBuilderId, tagId) {
    return api.delete(`${URL}/tags/${queryBuilderId}/${tagId}`)
  },
  getLimit() {
    return api.get(`${URL}/limit`)
  },
  getSysParameter(name) {
    return apiMipe.get(
      `api/sysparameter/byparameternames?parameterNames=${name}`
    )
  },
  inactivateTag(tagId) {
    return api.delete(`${URL}/inactivatetag/${tagId}`)
  },
  getTickets(payload) {
    return api.get(`${URL}/tickets`, {
      params: {
        ...payload
      }
    })
  },
  addTickets(payload) {
    return api.post(`${URL}/tickets`, payload)
  },
  removeTickets(payload) {
    return api.post(`${URL}/remove-ticket`, payload)
  },
  getTicketsByQueryBuilderId(queryBuilderId) {
    return api.get(`${URL}/tickets/${queryBuilderId}`)
  },
  hasTickets() {
    return api.get(`${URL}/hastickets`)
  },
}
